import { render, staticRenderFns } from "./invoiceAdmin.vue?vue&type=template&id=04a14fe2&scoped=true"
import script from "./invoiceAdmin.vue?vue&type=script&lang=js"
export * from "./invoiceAdmin.vue?vue&type=script&lang=js"
import style0 from "./invoiceAdmin.vue?vue&type=style&index=0&id=04a14fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a14fe2",
  null
  
)

export default component.exports